<template>
    <div class="page-cabinet-referral-info-link">
        <div class="page-cabinet-referral-info-link__description" v-if="user.referrerCode">
            Ваша уникальная ссылка для отправки друзьям, чтобы получать процент с их первой инвестиции.
        </div>
        <ui-card-base with-border v-if="user.referrerCode">
            <div class="page-cabinet-referral-info-link__data">
                <div class="page-cabinet-referral-info-link__data-link"
                    v-text="link"
                />
                <div class="page-cabinet-referral-info-link__data-button"
                    v-if="!isIE"
                    >
                    <ui-button
                        v-bind:disabled="isCopyInProgress"
                        v-on:click="copyLink"
                        text="Копировать"
                    />
                </div>
            </div>
        </ui-card-base>
    </div>
</template>

<script>
import config from '~/config';
import utils from '~/utils';

export default {
    name: 'page-cabinet-referral-info-link',
    data: () => ({
        isIE: utils.environments.isIE(),
        isCopyInProgress: false,
    }),
    computed: {
        user() {
            return this.$store.getters['users/user'];
        },
        link() {
            return `${config.urls.prodRoot}${config.urls.auth.login}?${config.common.referralQuery}=${this.user.referrerCode}`;
        },
    },
    methods: {
        copyLink() {
            this.isCopyInProgress = true;
            navigator.clipboard.writeText(this.link)
                .then(() => {
                    this.isCopyInProgress = false;
                });
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-referral-info-link {
    &__description {
        .typography-body();

        // max-width: 529px;
        margin-bottom: 16px;
    }
    &__data {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        &-link {
            .typography-heading();

            flex: 1 1 auto;

            word-break: break-all;
        }
        &-button {
            flex: 0 0 auto;
            width: 206px;
            margin-left: 40px;
        }
    }
    @media @media-sm-down {
        &__description {
            margin-bottom: 24px;
        }
        &__data {
            display: block;
            &-button {
                width: 100%;
                margin-left: 0;
                margin-top: 16px;
            }
        }
    }
}
</style>
